<template>
  <transition name="sheet-fade">
    <div v-if="visible" class="country-address-overlay" @click.self="close">
      <transition name="sheet-slide">
        <div v-if="visible" class="country-address-sheet">
          <div class="sheet-header">
            <div class="sheet-header-left align-center">
              <img src="~/assets/home/location.svg" class="header-icon" alt="" />
              <span class="header-title">{{ $t('home.country_address_modal_title') }}</span>
            </div>
            <img src="~/assets/house/close.svg" class="close-btn" alt="" @click="close" />
          </div>
          <div class="sheet-body">
            <div v-for="(country, index) in countryAddressList" :key="index" class="country-card">
              <div class="country-card-header align-center">
                <img v-if="country.flag" :src="country.flag" class="country-flag" alt="" />
                <span class="country-name">{{ country.name }}</span>
              </div>
              <div
                v-for="(addr, addrIndex) in country.addresses"
                :key="addrIndex"
                class="address-item"
              >
                <img src="~/assets/detail/map.svg" class="address-icon" alt="" />
                <span class="address-text">
                  <span class="address-city">{{ addr.city }}</span>
                  <span class="address-divider">|</span>
                  <span class="address-detail">{{ addr.detail }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { groupAddressList } from '~/utils/countryAddress'

export default {
  name: 'CountryAddressMobile',
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    countryAddressList() {
      return groupAddressList(this.$store.state.addressList)
    },
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
.country-address-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}

.country-address-sheet {
  width: 100%;
  max-height: 80vh;
  background: #fff;
  border-radius: 0.24rem 0.24rem 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.32rem 0.4rem 0.24rem;
  border-bottom: 0.01rem solid #f0f0f0;
  flex-shrink: 0;

  .sheet-header-left {
    display: flex;
    align-items: center;
  }

  .header-icon {
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.16rem;
  }

  .header-title {
    font-size: 0.32rem;
    font-weight: 600;
    color: #232c46;
    line-height: 1.4;
  }

  .close-btn {
    width: 0.48rem;
    height: 0.48rem;
    cursor: pointer;
    flex-shrink: 0;
    filter: invert(1);
  }
}

.sheet-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.32rem 0.4rem 0.48rem;
  -webkit-overflow-scrolling: touch;
}

.country-card {
  border: 0.02rem solid #e8e8e8;
  border-radius: 0.16rem;
  padding: 0.3rem 0.32rem;
  margin-bottom: 0.24rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.country-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;

  .country-flag {
    width: 0.48rem;
    height: 0.48rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 0.16rem;
    flex-shrink: 0;
  }

  .country-name {
    font-size: 0.3rem;
    font-weight: 600;
    color: #000;
    line-height: 1.4;
  }
}

.address-item {
  display: flex;
  align-items: flex-start;
  margin-top: 0.2rem;

  &:first-of-type {
    margin-top: 0;
  }

  .address-icon {
    width: 0.26rem;
    height: 0.26rem;
    margin-top: 0.04rem;
    margin-right: 0.12rem;
    flex-shrink: 0;
  }

  .address-text {
    font-size: 0.24rem;
    color: #727272;
    line-height: 1.6;
    word-break: break-word;
  }

  .address-city {
    color: #727272;
  }

  .address-divider {
    margin: 0 0.12rem;
    color: #727272;
  }

  .address-detail {
    color: #727272;
  }
}

// 遮罩淡入淡出
.sheet-fade-enter-active,
.sheet-fade-leave-active {
  transition: opacity 0.25s ease;
}
.sheet-fade-enter,
.sheet-fade-leave-to {
  opacity: 0;
}

// 底部上滑动画
.sheet-slide-enter-active,
.sheet-slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
}
.sheet-slide-enter,
.sheet-slide-leave-to {
  transform: translateY(100%);
}
</style>
